import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Input,
  Badge,
} from 'reactstrap';

class AddCampaignInput extends React.PureComponent {
  componentDidMount() {
    const { id } = this.props;
    this.handleChange({ target: { id } });
  }

  validate = (value) => {
    const { pattern } = this.props;
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  };

  handleChange = ({ target }) => {
    const { dispatch } = this.props;
    const { id } = target;
    let { value } = target;

    const valid = this.validate(value || '');

    const numberValues = ['q_to_shoppers', 'es_to_quotes', 'ec_to_enrollments', 'es_to_shoppers', 'ec_to_shoppers'];
    if (numberValues.includes(id)) {
      value = Number(value);
    }

    dispatch({
      type: 'EDIT_ADD_CAMPAIGN',
      id,
      value,
      valid,
    });
  };

  render() {
    const {
      values,
      value,
      id,
      validations,
      errors,
      label,
      feedback,
      disabled,
      type,
    } = this.props;
    const valid = validations[id];
    const error = errors[id];

    return (
      <FormGroup>
        <Label for={id} className="font-weight-bold">
          {label}
        </Label>
        {error && (
          <Badge color="danger" className="ms-2">{feedback}</Badge>
        )}
        <Input
          id={id}
          name={id}
          className="border"
          value={value || values[id] || ''}
          invalid={!valid}
          onChange={this.handleChange}
          disabled={disabled}
          type={type}
        />
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.addcampaign.values,
  validations: store.addcampaign.validations,
  errors: store.addcampaign.errors,
});

export default connect(mapStateToProps)(AddCampaignInput);
